<template>
    <div class="dml-category-title">
        <div class="dml-category-title__wrapper">
            <div class="dml-category-title__arrow"  v-on:click="handleClick">
                <dm-icon name="arrow-left-short" :width="24" :height="24" />
            </div>
            <h1 class="dml-category-title__text">
                {{title.sub}}
            </h1>
        </div>
        <dm-category-info />
    </div>
</template>

<script>
    import * as types from '../../store/types.js';
    import CategoryInfoComponent from './category-info-component.vue';
    import IconComponent from '../shared/icon-component.vue';

    export default {
        name: 'dm-category-header',
        components: {
            'dm-category-info': CategoryInfoComponent,
            'dm-icon': IconComponent,
        },
        computed: {
            title() {
                return this.$store.getters.title;
            },
            categoryParentId() {
                return this.$store.getters.categoryParentId;
            },
            categoryParentUrl() {
                return this.$store.getters.parentSeo;
            },
            landingPageUrl() {
                return this.$store.getters.landingPageUrl;
            }
        },
        methods: {
            handleClick() {
                if (this.categoryParentUrl) {
                    this.$store.dispatch(types.FETCH_CURRENT_MODEL, `${this.categoryParentUrl}`);
                } else if(this.landingPageUrl){
                    window.location.href = this.landingPageUrl;
                }
                else {
                    window.location.href = '/';
                }

                this.$ga.trackEvent({
                    category: 'm_categories',
                    action: 'click_back',
                    label: 'Przejdź poziom wyżej'
                });
            }
        }
    };
</script>
